import React from "react";
import ReactModal from "react-modal";

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message?: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmButtonClass?: string;
  cancelButtonClass?: string;
  width?: string;
}

const defaultModalStyles = (width: string): ReactModal.Styles => ({
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width,
    borderRadius: "8px",
    padding: "0",
    border: "none",
    boxShadow: "0 10px 40px rgba(0,0,0,0.15)",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.45)",
    zIndex: 9999,
  },
});

const NonActionableConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  confirmButtonClass = "btn btn-primary",
  cancelButtonClass = "btn btn-secondary",
  width = "420px",
}) => {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={defaultModalStyles(width)}
      contentLabel={title}
      shouldCloseOnOverlayClick={false}
      ariaHideApp={false}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "16px 20px",
          borderBottom: "1px solid #e5e7eb",
        }}
      >
        <h5
          style={{
            margin: 0,
            fontSize: "16px",
            fontWeight: 600,
            color: "#111827",
          }}
        >
          {title}
        </h5>
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: "4px",
            color: "#6b7280",
            fontSize: "18px",
            lineHeight: 1,
          }}
        >
          &times;
        </button>
      </div>

      {/* Body */}
      <div
        style={{
          padding: "20px",
          fontSize: "14px",
          color: "#374151",
          lineHeight: "1.6",
        }}
      >
        {message}
      </div>

      {/* Footer */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
          padding: "14px 20px",
          borderTop: "1px solid #e5e7eb",
          backgroundColor: "#f9fafb",
          borderRadius: "0 0 8px 8px",
        }}
      >
        <button type="button" className={cancelButtonClass} onClick={onClose}>
          {cancelLabel}
        </button>
        <button
          type="button"
          className={confirmButtonClass}
          onClick={() => {
            onConfirm();
            onClose();
          }}
        >
          {confirmLabel}
        </button>
      </div>
    </ReactModal>
  );
};

export default NonActionableConfirmationModal;